import React from "react";
import { cn } from "../../../lib/cn";

/**
 * Select — desplegable nativo estilizado con icono de chevron.
 *
 * @example
 * <Select value={mes} onChange={e => setMes(e.target.value)}>
 *   <option value="01">Enero</option>
 *   <option value="02">Febrero</option>
 * </Select>
 */
export const Select = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          "flex h-9 w-full appearance-none rounded-md border border-input bg-background pl-3 pr-9 py-1 text-sm",
          "shadow-sm transition-colors cursor-pointer",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...props}
      >
        {children}
      </select>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
      </svg>
    </div>
  );
});
Select.displayName = "Select";
